export default __webpack_public_path__ + "static/media/card_front_blank.917df622.svg";